import React from "react";

import clsx from "clsx";
import Image from "next/image";

import FigureImage from "public/images/enerflo-solar-platform-integrated-solar-financing.png";

import HeroSection from "../../hero-section";
import styles from "./index.module.css";
import TimelineContent from "./timeline-content";

const title = "Integrated Financing";

const Financing = () => (
  <div className={clsx("timeline-section-wrapper", styles.timelineSectionWrapper)}>
    <HeroSection title={title} className={styles.timelineSection}>
      <div className={styles.timelineSectionGrid}>
        <TimelineContent
          title={title}
          description="With 90% of solar deals on Enerflo being financed, it needs to be seamless. Enerflo’s integration with the top 5 Solar Lenders enables quick approvals with NO portal logins and NO manual entry. We make applying, receiving approvals and doc signing a breeze. And, as lenders get more progressive with their integrations, Enerflo is at the forefront to ensure we’re utilizing all of their latest technology."
          link="/features/lendflo"
          icon={
            <Image
              src="/images/icons/financing.svg"
              alt="Icon - Enerflo Financing"
              layout="responsive"
              height={68}
              width={58}
              quality={100}
              className="crispImage"
            />
          }
        />
        <figure className={clsx(styles.timelineFigure, styles.offsetContent)}>
          <div className="mx-auto xs:w-2/3 md:w-[125%] md:ml-[-25%]">
            <Image
              src={FigureImage}
              alt="Quickly and easily apply for solar financing and get approvals from the top 5 solar lenders with Enerflo financing."
              layout="responsive"
              quality={100}
              placeholder="blur"
              className="crispImage"
              sizes="(min-width: 768px) 50vw, 100vw"
              lazyBoundary="400px"
            />
          </div>
        </figure>
      </div>
    </HeroSection>
  </div>
);
export default Financing;
